import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import '@angular/localize/init';
import { provideCharts } from 'ng2-charts';
import { BarController, Colors, Legend } from 'chart.js';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error());

provideCharts({ registerables: [BarController, Legend, Colors] });